const sideConversationPricingPlans = ['super', 'standard-psa', 'nfr'];
const noRestrictionToPlans = ['nfr', 'not-for-resale---it'];

export { sideConversationPricingPlans, noRestrictionToPlans };
